import React, { useState, useEffect, useContext } from "react";
import { Form, Modal, Button } from "react-bootstrap";
import ModalFooter from "./UserPageForms/ModalFooter";
import { deleteUser, updateUser } from "../Services/ReportingService.js";
import { NotificationsContext } from "../Contexts/NotificationsContext";
import { formatCurrency } from "../Util/Utils.js";
import PuffLoader from "react-spinners/PuffLoader";
import { allBundles } from "../Util/Constants";
import { allItaasBundles } from "../Util/Constants";
import { allAsanaBundles } from "../Util/Constants";
import { allCopilotBundles } from "../Util/Constants";
import { allAdobeAcrobatProBundles } from "../Util/Constants";
import { allTeamsPhoneBundles } from "../Util/Constants";
import "../style/ALaCarteModal.css";

const ALaCarteModal = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [askForDeleteConfirmation, setAskForDeleteConfirmation] = useState(false);

  const { addNotification } = useContext(NotificationsContext);

  useEffect(() => {
    setIsLoading(false);
    setAskForDeleteConfirmation(false);
    setIsDeleting(false);
  }, [props.show]);

  const onEmployeeChange = async (field, value, employee) => {
    const newBundleId = props.licenseBundlesNameToBundle.get(value).bundleId;
    props.setEmployee({ ...employee, [field]: newBundleId });
  };

  const onSaveClick = async () => {
    setIsLoading(true);

    try {
      await updateUser(props.employee);
      props.onHide();
      addNotification({
        show: true,
        type: "Success",
        description: "Updated User Successfully",
      });
    } catch (error) {
      console.error(error);
      addNotification({
        show: true,
        type: "Error",
        description: (
          <>
            Updating User Failed. Please contact
            <b>itsupport@gocitywide.com</b> for assistance.
          </>
        ),
      });
    }

    await props.fetchUserBundleLicenses();
  };

  const onDeleteClick = async () => {
    if (!askForDeleteConfirmation) {
      setAskForDeleteConfirmation(true);
    } else {
      setIsDeleting(true);
      try {
        await deleteUser(props.employee);
        props.onHide();
        addNotification({ show: true, type: "Success", description: "Deleted User Successfully" });
      } catch (error) {
        setIsDeleting(false);
        console.error(error);
        addNotification({
          show: true,
          type: "Error",
          description: (
            <>
              Failed to Delete User. We ran into an issue submitting your request. Please contact
              <b>itsupport@gocitywide.com</b> for assistance.
            </>
          ),
        });
      }

      await props.fetchUserBundleLicenses();
    }
  };

  return (
    <Modal show={props.show} onHide={props.onHide} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Employee Details - {props.employee.fullName}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="alacarte-body">
        <div className="alacarte-section">
          <div className="alacarte-section-title">Licenses</div>
          <div className="alacarte-row">
            <div className="alacarte-label">Bundle</div>
            <Form className="alacarte-select">
              <Form.Group controlId="updateUserSelect">
                <Form.Select
                  custom
                  disabled={props.readOnly}
                  value={props.licenseBundlesIdToBundle.get(props.employee.licenseBundleId).bundleName}
                  onChange={(value) => onEmployeeChange("licenseBundleId", value.target.value, props.employee)}
                >
                  {allBundles.map((option) => (
                    <option key={option}>{option}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Form>
            <div className="alacarte-price">
              {formatCurrency(props.licenseBundlesIdToBundle.get(props.employee.licenseBundleId).bundlePrice)}
            </div>
          </div>
          <div className="alacarte-row">
            <div className="alacarte-label">ItaaS</div>
            <Form className="alacarte-select">
              <Form.Group controlId="showItaasLevel">
                <Form.Select
                  custom
                  disabled={props.readOnly}
                  value={props.licenseBundlesIdToBundle.get(props.employee.itaasPackageId).bundleName}
                  onChange={(value) => onEmployeeChange("itaasPackageId", value.target.value, props.employee)}
                >
                  {allItaasBundles.map((bundle) => (
                    <option key={bundle}>{bundle}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Form>
            <div className="alacarte-price">
              {formatCurrency(props.licenseBundlesIdToBundle.get(props.employee.itaasPackageId).bundlePrice)}
            </div>
          </div>
        </div>
        <div className="alacarte-section">
          <div className="alacarte-section-title">A La Carte</div>
          <div className="alacarte-row">
            <div className="alacarte-label">Asana</div>
            <Form className="alacarte-select">
              <Form.Group controlId="updateAsanaSelect">
                <Form.Select
                  custom
                  disabled={props.readOnly}
                  value={props.licenseBundlesIdToBundle.get(props.employee.asanaPackageId).bundleName}
                  onChange={(value) => onEmployeeChange("asanaPackageId", value.target.value, props.employee)}
                >
                  {allAsanaBundles.map((bundle) => (
                    <option key={bundle}>{bundle}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Form>
            <div className="alacarte-price">
              {formatCurrency(props.licenseBundlesIdToBundle.get(props.employee.asanaPackageId).bundlePrice)}
            </div>
          </div>
          <div className="alacarte-row">
            <div className="alacarte-label">Copilot</div>
            <Form className="alacarte-select">
              <Form.Group controlId="updateCopilotSelect">
                <Form.Select
                  custom
                  disabled={props.readOnly}
                  value={props.licenseBundlesIdToBundle.get(props.employee.copilotPackageId).bundleName}
                  onChange={(value) => onEmployeeChange("copilotPackageId", value.target.value, props.employee)}
                >
                  {allCopilotBundles.map((bundle) => (
                    <option key={bundle}>{bundle}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Form>
            <div className="alacarte-price">
              {formatCurrency(props.licenseBundlesIdToBundle.get(props.employee.copilotPackageId).bundlePrice)}
            </div>
          </div>
          <div className="alacarte-row">
            <div className="alacarte-label">Adobe Acrobat Pro</div>
            <Form className="alacarte-select">
              <Form.Group controlId="updateAdobeAcrobatProSelect">
                <Form.Select
                  custom
                  disabled={props.readOnly}
                  value={props.licenseBundlesIdToBundle.get(props.employee.adobeAcrobatProPackageId).bundleName}
                  onChange={(value) => onEmployeeChange("adobeAcrobatProPackageId", value.target.value, props.employee)}
                >
                  {allAdobeAcrobatProBundles.map((bundle) => (
                    <option key={bundle}>{bundle}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Form>
            <div className="alacarte-price">
              {formatCurrency(props.licenseBundlesIdToBundle.get(props.employee.adobeAcrobatProPackageId).bundlePrice)}
            </div>
          </div>
          <div className="alacarte-row">
            <div className="alacarte-label">Teams Phone</div>
            <Form className="alacarte-select">
              <Form.Group controlId="updateTeamsPhoneSelect">
                <Form.Select
                  custom
                  disabled={props.readOnly}
                  value={props.licenseBundlesIdToBundle.get(props.employee.teamsPhonePackageId).bundleName}
                  onChange={(value) => onEmployeeChange("teamsPhonePackageId", value.target.value, props.employee)}
                >
                  {allTeamsPhoneBundles.map((bundle) => (
                    <option key={bundle}>{bundle}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Form>
            <div className="alacarte-price">
              {formatCurrency(props.licenseBundlesIdToBundle.get(props.employee.teamsPhonePackageId).bundlePrice)}
            </div>
          </div>
        </div>
        <div className="alacarte-summary">
          {!props.readOnly && (
            <>
              {isDeleting ? (
                <div className="delete-loader-container">
                  <PuffLoader size={40} color={"black"} loading={true} />
                </div>
              ) : (
                <Button
                  type="button"
                  data-testid="modal-footer-delete-button"
                  className="delete-user-button"
                  onClick={onDeleteClick}
                >
                  {askForDeleteConfirmation ? "Confirm Delete" : "Delete User"}
                </Button>
              )}
            </>
          )}
          <div className="alacarte-total">
            <span className="alacarte-total-label">Total</span>
            <span className="alacarte-total-amount">{props.getTotalPrice(props.employee)}</span>
          </div>
        </div>
      </Modal.Body>
      {!props.readOnly && (
        <ModalFooter
          onSubmitClick={onSaveClick}
          submitLoading={isLoading}
          onHide={props.onHide}
          submitButtonText="Save"
        />
      )}
    </Modal>
  );
};

export default ALaCarteModal;
